export default {"src":"https://wp-static.smartkarma.com/_next/static/media/home-inactive.1475e640.svg","height":1005,"width":1005,"blurWidth":0,"blurHeight":0};